import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';
import { APP_NAME } from '../constants/app';

const Logo = ({ variant = 'text', size = 'medium' }) => {
  const { t } = useLanguage();
  const theme = useTheme();

  const getLogoContent = () => {
    switch (variant) {
      case 'icon':
        return (
          <Box
            sx={{
              width: size === 'small' ? 30 : 40,
              height: size === 'small' ? 30 : 40,
              bgcolor: theme.palette.primary.main,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
            }}
          >
            <Typography variant="h6" component="span">
              PCM
            </Typography>
          </Box>
        );
      case 'text':
        return (
          <Typography
            variant={size === 'small' ? 'h6' : 'h4'}
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              textTransform: 'uppercase',
            }}
          >
            {t('common.appName', 'Personal Finance: PCM Planning, Controlling & Monitoring')}
          </Typography>
        );
      default:
        return null;
    }
  };

  return getLogoContent();
};

export default Logo;
